import axios from 'axios';
import { Envelope } from '../interfaces/envelope';
import { Role } from '../interfaces/types';
import { AlertType } from '../interfaces/reference';

async function getRoles(): Promise<Role[]> {
	try {
		const response = await axios.get<Envelope<Role[]>>(`reference/roles`);
		return response.data.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response!.data;
		}
		throw error;
	}
}

async function getAlertTypes(): Promise<AlertType[]> {
	try {
		const response = await axios.get<Envelope<AlertType[]>>(`reference/alerttypes`);
		return response.data.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response!.data;
		}
		throw error;
	}
}

export const reference = {
	getRoles,
	getAlertTypes,
};
